import { useEffect } from 'react'

/**
 * блокировка скролла при открытии модального окна
 */
export const useLockScroll = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      document.body.setAttribute('style', 'overflow: hidden !important')
      document.getElementsByTagName('html')[0].style.overflow = 'hidden'
    }

    return () => {
      document.body.style.overflow = ''
      document.getElementsByTagName('html')[0].style.overflow = ''
    }
  }, [isOpen])
}
